import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import './App.scss';
// import axios from 'axios';

import './assets/scss/app.scss';
import App from './App';
import rootReducer from './store/reducers';


const composeEnhancers =  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

// axios.defaults.baseURL = 'http://foodna-api.codebnb.me:8070/api/v0';
// console.log(store.getState().auth.token);
// axios.defaults.headers.common['Authorization'] = store.getState().auth.token;


const app = (
    <Provider store={ store }>
        <BrowserRouter>
            <MuiThemeProvider>
                <App />
            </MuiThemeProvider>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js